import React, { Component, PropTypes } from 'react';
import { countries } from '../../../utils/select-fields';
import { getGeoLocation } from '../../../utils/address';
import { TextField } from 'material-ui';
import Select from 'react-select';

import languagesObj from '../../../localization/languages.json';
const languageSettings = languagesObj['en-US'];

class AddressEdit extends Component {

  constructor(props) {
    super();
    const address = props.address;
    this.state = {
      addressOne: address.addressOne,
      addressTwo: address.addressTwo,
      city: address.city,
      state: address.state,
      postalCode: address.postalCode,
      country: address.country,
    };
  }

  componentDidMount() {
    this.props.checkIfValidAddress(this.checkIfValidAddress());
  }

  _updateValue = (field, fn, event) => {
    const updater = {};
    updater[field] = event.target.value;
    this.setState(updater, () => {
      if (fn) fn(this.checkIfValidAddress());
    });
  };

  _validateField = (field) => {
    const fieldToSet = `${field}Validated`;
    const update = {};
    if (this.state[field]) {
      if (this.state[fieldToSet]) return;
      update[fieldToSet] = true;
    } else {
      if (this.state[fieldToSet] || this.state[fieldToSet] === undefined) {
        update[fieldToSet] = false;
      }
    }
    this.setState(update);
  };

  checkIfValidAddress = () => {
    return Boolean(
      this.state.addressOne &&
      this.state.city &&
      this.state.state &&
      this.state.country &&
      this.state.postalCode
    );
  };

  _updateCountryValue = ({ value: country }) => {
    this.setState({ country }, () => {
      this.props.checkIfValidAddress(this.checkIfValidAddress());
    });
  };

  _getAddressForDialogConfirmation = () => {
    let commaIndex = -1;
    let addressOne = '';
    let addressTwo = '';
    let everythingElse = '';
    const { addressToConfirm } = this.props;
    if (addressToConfirm && addressToConfirm.formattedAddress) {
      commaIndex = addressToConfirm.formattedAddress.indexOf(',');
      addressOne = commaIndex > -1 ? addressToConfirm.formattedAddress.substr(0, commaIndex) : addressToConfirm.formattedAddress;
      addressTwo = this.state.addressTwo;
      if (this.state.country === 'United Kingdom' && this.state.state !== addressToConfirm.state) {
        everythingElse = commaIndex > -1 ? `${this.state.city}, ${addressToConfirm.state} ${this.state.postalCode}` : '';
      } else {
        everythingElse = commaIndex > -1 ? addressToConfirm.formattedAddress.substr(commaIndex + 2) : '';
      }
    } else {
      addressOne = this.state.addressOne;
      addressTwo = this.state.addressTwo;
      everythingElse = `${this.state.city} ${this.state.state} ${this.state.country}`;
    }
    if (addressTwo) return `\n\n${addressOne}\n${addressTwo}\n${everythingElse}\n\n`;
    return `\n\n${addressOne}\n${everythingElse}\n\n`;
  };

  geoLocateAndConfirmAddress(fn) {
    getGeoLocation(this.state, (address) => {
      fn(Boolean(address && address.formattedAddress), address);
    });
  }

  saveAddress = (fn, skipGeolocation) => {
    const state = this.state;
    const address = this.props.addressToConfirm;
    const addressToSave = skipGeolocation ? state : Object.assign(state, address);
    fn({
      updateField: 'address',
      updateBody: {
        addressOne: addressToSave.addressOne,
        addressTwo: addressToSave.addressTwo,
        city: addressToSave.city,
        state: addressToSave.state,
        postalCode: addressToSave.postalCode,
        country: addressToSave.country,
        formattedAddress: addressToSave.formattedAddress,
        coordinates: addressToSave.coordinates,
      },
    });
  };

  render() {
    const initialInputValue = this.state.country;
    let content;
    if (this.props.needsToConfirmAddress) {
      if (this.props.addressToConfirm && this.props.addressToConfirm.formattedAddress) {
        content = (<div style={{ whiteSpace: 'pre-wrap' }}>
                    Is This Your Correct Address?
                    {this._getAddressForDialogConfirmation()}
                    If not please go back and check your inputs or hit skip to save your inputted address and skip geolocation.
                  </div>);
      } else {
        content = (<div style={{ whiteSpace: 'pre-wrap' }}>
                    We were unable to locate your address. Can you check your address again? If the following address you inputed is correct, then hit yes to skip geolocation:
                    {this._getAddressForDialogConfirmation()}
                  </div>);
      }
    } else {
      content = (
        <div>
          <TextField
            errorText={this.state.addressOneValidated !== undefined && !this.state.addressOneValidated && 'Required'}
            ref="addressOne"
            value={this.state.addressOne}
            floatingLabelText={languageSettings.onboarding.addressOnePlaceholder}
            style={{ width: '100%' }}
            onBlur={this._validateField.bind(this, 'addressOne')}
            onChange={this._updateValue.bind(this, 'addressOne', this.props.checkIfValidAddress)}
          />
          <div className="profile-edit-address-break"/>
          <TextField
            ref="addressTwo"
            value={this.state.addressTwo}
            floatingLabelText={languageSettings.onboarding.addressTwoPlaceholder}
            style={{ width: '100%' }}
            onBlur={this._validateField.bind(this, 'addressTwo')}
            onChange={this._updateValue.bind(this, 'addressTwo', null)}
          />
          <div className="profile-edit-address-break"/>
          <TextField
            errorText={this.state.cityValidated !== undefined && !this.state.cityValidated && 'Required'}
            ref="city"
            value={this.state.city}
            floatingLabelText={languageSettings.onboarding.city}
            style={{ width: '100%' }}
            onBlur={this._validateField.bind(this, 'city')}
            onChange={this._updateValue.bind(this, 'city', this.props.checkIfValidAddress)}
          />
          <div className="profile-edit-address-break"/>
          <div className="form-line">
            <div className="form-line-two">
              <TextField
                errorText={this.state.stateValidated !== undefined && !this.state.stateValidated && 'Required'}
                ref="state"
                value={this.state.state}
                floatingLabelText={languageSettings.onboarding.statePlaceholder}
                style={{ width: '100%' }}
                onBlur={this._validateField.bind(this, 'state')}
                onChange={this._updateValue.bind(this, 'state', this.props.checkIfValidAddress)}
              />
            </div>
            <div className="form-line-two">
              <TextField
                errorText={this.state.postalCodeValidated !== undefined && !this.state.postalCodeValidated && 'Required'}
                ref="postalCode"
                value={this.state.postalCode}
                floatingLabelText={languageSettings.onboarding.zipPlaceholder}
                style={{ width: '100%' }}
                onBlur={this._validateField.bind(this, 'postalCode')}
                onChange={this._updateValue.bind(this, 'postalCode', this.props.checkIfValidAddress)}
              />
            </div>
          </div>
          <Select
            wrapperStyle={{ position: 'absolute', width: '94%' }}
            name="country"
            onChange={this._updateCountryValue}
            options={countries}
            value={initialInputValue}
            placeholder="Search & Pick A Country"
            clearable={false}
            scrollMenuIntoView={false}
          />
        </div>

      );
    }

    return (
      <div id="address">
        {content}
      </div>
    );
  }
}

AddressEdit.propTypes = {
  address: PropTypes.object,
  checkIfValidAddress: PropTypes.func,
  addressToConfirm: PropTypes.object,
  needsToConfirmAddress: PropTypes.bool,
};

export default AddressEdit;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/profile/edit-modal/company-address-edit.jsx